<app-header></app-header>
<div class="main">
    <!-- <h1>{{ title }}</h1> -->
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>